import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Tag from '../../../../components/presentation/Tag'

const getProps = (status, t) => {
  switch (status) {
    case 'open':
      return { label: t('importing'), color: COLORS.dark3 }
    case 'error':
      return { label: t('error'), color: COLORS.red }
    default:
      return { label: t('completed'), color: COLORS.green }
  }
}

const StatusTag = ({ status, importRecord }) => {
  const { t } = useTranslation('import')
  // TODO: Remove after all is migrated to new import

  if (!status) {
    if (!!importRecord?.outputDocument?.id) {
      status = 'error'
    } else {
      if (importRecord?.percentage >= 100) {
        status = 'done'
      } else {
        status = 'open'
      }
    }
  }
  const { label, color } = getProps(status, t)
  return <Tag transparent label={label} color={color} />
}

export default StatusTag
